import React from 'react';

import { Shield, ThumbUp } from '@sravni/react-icons';

interface IStatusBadgeInfo {
  isResolved: boolean;
  ratingStatus: string;
}

export const getStatusBadgeInfo = ({ isResolved, ratingStatus }: IStatusBadgeInfo) => {
  if (isResolved)
    return {
      text: 'Проблема решена',
      icon: <ThumbUp />,
    };

  if (['rateApproved', 'rateIncluded'].includes(ratingStatus))
    return {
      text: 'Проверен',
      icon: <Shield />,
    };

  return null;
};
